import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
} from "@mui/material";

export default function CreateLeagueDialog({
  open,
  onClose,
  leagueName,
  setLeagueName,
  onCreate,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Create League</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="name"
              label="League Name"
              fullWidth
              value={leagueName}
              variant="standard"
              onChange={(e) => setLeagueName(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onCreate} autoFocus disabled={leagueName.length < 3}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
